import { action, observable } from 'mobx'

export default class {
  @observable showExtend = false
  @action
  init = value => {
    if (value) {
      const { id, title } = value
      this.showExtend = id === undefined || id === '-1' || (id === '' && title)
    }
  }
}
